// extracted by mini-css-extract-plugin
module.exports = {"heading":"HeadingPanel_heading__2q69s","activeHeading":"HeadingPanel_activeHeading__3OYis"};